export class FieldValueTranslator {
	constructor(toDisplayTranslator, toStorageTranslator) {
		this.toDisplayTranslator = toDisplayTranslator;
		this.toStorageTranslator = toStorageTranslator;
	}

	toDisplayValue(value) {
		return this.toDisplayTranslator ? this.toDisplayTranslator(value) : value;
	}

	toStorageValue(value) {
		return this.toStorageTranslator ? this.toStorageTranslator(value) : value;
	}
}

export const UtilTranslators = {
	stringToInt: (value) => {
		if (!value) return null;
		if (typeof value === "string") {
			return Number.parseInt(value,10);
		} else if (typeof value === "number") {
			return value;
		}
		return NaN;
	},

	stringToFloat: (value) => {
		if (!value) return null;
		if (typeof value === "string") {
			return Number.parseFloat(value,10);
		} else if (typeof value === "number") {
			return value;
		}
		return NaN;
	},

	//Not really very useful. It returns a Number object which 
	//doesn't convert to JSON automatically.
	stringToNumber: (value) => {
		if (!value) return null;
		if (typeof value === "string") {
			return Number(value);
		} else if (typeof value === "number") {
			return value;
		}
		return NaN;
	},

	//Calls `value.toString`. If value is null or does not have
	//a `toString` method, null is returned.
	anyToString: (value) => {
		return value !== null && value.toString !== null ? value.toString() : null;
	}
};

export const NumberFieldValueTranslator = new FieldValueTranslator(UtilTranslators.anyToString, UtilTranslators.stringToFloat);



// WEBPACK FOOTER //
// ./src/components/form/FieldValueTranslator.js